import Vue from "vue";
import VueX from "vuex";
import store from "./store";
import routes from "./config/PageRoutes";

// plugins
import VueRouter from "vue-router";
import VueBootstrap from "bootstrap-vue";
import VueNVD3 from "vue-nvd3";
import VueInsProgressBar from "vue-ins-progress-bar";
import VuePanel from "./plugins/panel/";

// plugins css
import "@/assets/icons/iconfont.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "flag-icon-css/css/flag-icon.min.css";
import "bootstrap-social/bootstrap-social.css";
// import "ionicons/dist/css/ionicons.min.css";

// color admin css

import Viewer from "v-viewer"; // 图片放大缩小
import "viewerjs/dist/viewer.css";
import "view-design/dist/styles/iview.css";
import "./assets/css/default/style.min.css";
import "./assets/css/default/style-responsive.min.css";
import "./assets/css/default/theme/default.css";
import "./assets/css/style.css";
import "./assets/css/custom.css";

Vue.use(Viewer);
Vue.use(VueNVD3);
Vue.use(VueInsProgressBar);

// import VueCodemirror from "vue-codemirror";
// import "codemirror/lib/codemirror.css";
// Vue.use(VueCodemirror);
import ViewUI from "view-design";
Vue.use(ViewUI);

import App from "./App.vue";

Vue.config.productionTip = false;

Vue.use(VueX);
Vue.use(VueRouter);
Vue.use(VueBootstrap);
Vue.use(VuePanel);

const router = new VueRouter({
  routes,
  mode: "history"
});

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");
